import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GTMService } from '@services';
import { DevicesStore, InstallationFeaturesStore } from '@store';
import {
  DeviceNameCommands,
  Feature,
  FeatureCommands,
  FeatureNames,
  FeaturePropertyKey,
  IsNumberValueProperty,
  IsStringValueProperty,
  SetNumberValueCommands,
} from '@vi-iot/client/index';
import { Observable, Subject, takeUntil } from 'rxjs';
import { EditDeviceNameModalComponent } from 'src/app/+installations/single-room-control/edit-device-name-modal/edit-device-name-modal.component';
import { SharedDependenciesModule } from 'src/app/shared';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';

@Component({
  selector: 'app-dry-contact-heat-pump-overlay',
  standalone: true,
  imports: [CommonStandaloneModule, SharedDependenciesModule],
  templateUrl: './dry-contact-heat-pump-overlay.component.html',
  styleUrl: './dry-contact-heat-pump-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DryContactHeatPumpOverlayComponent implements OnInit, OnDestroy {
  readonly FeaturePropertyKey = FeaturePropertyKey;
  readonly FeatureCommands = FeatureCommands;
  deviceName$: Observable<Feature<IsStringValueProperty, DeviceNameCommands>>;
  powerNominal$: Observable<Feature<IsNumberValueProperty, SetNumberValueCommands>>;

  private deviceId: string;
  private ngUnsubscribe$: Subject<void> = new Subject();

  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    private gtmService: GTMService,
    private dialog: MatDialog,
    private devicesStore: DevicesStore
  ) {}

  ngOnInit(): void {
    this.devicesStore.dryContactHeatPump$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((device) => {
        this.deviceId = device.id;
        this.setFeatureObservables();
      });
  }

  private setFeatureObservables(): void {
    this.deviceName$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceName,
      this.deviceId
    );

    this.powerNominal$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.dryContactPowerNominal,
      this.deviceId
    );
  }

  openEditModal(): void {
    this.gtmService.track('onOpen', 'Edit Device Name modal', 'singleRoomControl');
    this.dialog.open(EditDeviceNameModalComponent, {
      width: '715px',
      panelClass: 'commissioning-edit-room-dialog',
      data: {
        deviceId: this.deviceId,
      },
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
